import env from '../../helpers/env';
import haveDisplayMedia from '../../helpers/haveGetDisplayMedia';

const isSupportedInThisBrowser = () =>
  // Even though getDisplayMedia is supported in Edge, we haven't gotten it
  // to work with our SDK
  !env.isLegacyEdge &&

  // Even though getDisplayMedia is exposed in Electron, devs need to use
  // desktopCapturer instead
  !env.isElectron && haveDisplayMedia &&

  // getDisplayMedia is not supported in Android
  !env.isAndroid;

export default {
  isSupportedInThisBrowser: isSupportedInThisBrowser(),
  autoRegisters: true,
  extensionRequired: false,
  getConstraintsShowsPermissionUI: false,
  sources: {
    screen: true,
    application: false,
    window: env.name !== 'Safari',
    browser: env.name !== 'Safari',
  },
  register() {
    return {
      isInstalled(callback) {
        callback(undefined);
      },
      getConstraints(source, constraints, callback) {
        callback(undefined, {
          video: constraints.video,
          audio: constraints.audio,
        });
      },
    };
  },
};
